module.exports = __webpack_public_path__ + "static/media/timeline-step-3.d49f19ce.png";